module.exports = __webpack_public_path__ + "static/media/ste_2016_rimini_4.8ef653db.jpg";